import Label from '../label';
import React from 'react';
import {useSelector} from 'react-redux';
import './index.css';

function RecentGroup () {

	const profile = useSelector( state => state.profileReducer.getProfile);

	return (
		<div className="recent-group border-bottom">
			<Label
				id={0}
				name={'Latest contacts'}
				ownerId={profile.id}
				ownerName={profile.name}
				status={'READ_ONLY'}
				permission={'OWNER'}
				type={"recent"}
			/>
		</div>
	)
}

export default RecentGroup;
